import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		// console.log(err);
	})
}

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'index',
			component: () => import('../pages/index.vue'),
			meta: {
				title: '首页'
			},
		},
		{
			path: '/news',
			name: 'news',
			component: () => import('../pages/news.vue'),
			meta: {
				title: '集团资讯'
			},
		},
		{
			path: '/news-detail',
			name: 'news-detail',
			component: () => import('../pages/news-detail.vue'),
			meta: {
				title: '资讯详情'
			},
		},
		{
			path: '/business',
			name: 'business',
			component: () => import('../pages/business.vue'),
			meta: {
				title: '业务领域'
			},
		},
		{
			path: '/recruit',
			name: 'recruit',
			component: () => import('../pages/recruit.vue'),
			meta: {
				title: '人才招聘'
			},
		},
		{
			path: '/about',
			name: 'about',
			component: () => import('../pages/about.vue'),
			meta: {
				title: '关于我们'
			},
		},
		{
			path: '/admin',
			name: 'admin-login',
			component: () => import('../pages/admin/login.vue'),
			meta: {
				title: '登录'
			},
		},
		{
			path: '/admin/logout',
			name: 'logout',
			component: () => import('../pages/admin/logout.vue'),
			meta: {
				title: '未登录'
			},
		},
		{
			path: '/admin/index',
			name: 'admin-index',
			component: () => import('../pages/admin/index.vue'),
			meta: {
				title: '首页'
			},
		},
		{
			path: '/admin/news-list',
			name: 'admin-news-list',
			component: () => import('../pages/admin/news-list.vue'),
			meta: {
				title: '资讯列表'
			},
		},
		{
			path: '/admin/news-ad',
			name: 'admin-news-ad',
			component: () => import('../pages/admin/news-ad.vue'),
			meta: {
				title: '发布资讯'
			},
		},
		{
			path: '/admin/news-type',
			name: 'admin-news-type',
			component: () => import('../pages/admin/news-type.vue'),
			meta: {
				title: '资讯类型管理'
			},
		},
		{
			path: '/admin/user',
			name: 'admin-user',
			component: () => import('../pages/admin/user.vue'),
			meta: {
				title: '用户管理'
			},
		},
		{
			path: '/admin/user-ad',
			name: 'admin-user-ad',
			component: () => import('../pages/admin/user-ad.vue'),
			meta: {
				title: '添加|编辑用户'
			},
		},
		{
			path: '/admin/user-info',
			name: 'admin-user-info',
			component: () => import('../pages/admin/user-info.vue'),
			meta: {
				title: '个人资料'
			},
		},
		{
			path: '/admin/business-type',
			name: 'admin-business-type',
			component: () => import('../pages/admin/business-type.vue'),
			meta: {
				title: '业务管理'
			},
		},
		{
			path: '/admin/hire',
			name: 'admin-hire',
			component: () => import('../pages/admin/hire.vue'),
			meta: {
				title: '招聘管理'
			},
		},
		{
			path: '/admin/hire-ad',
			name: 'admin-hire',
			component: () => import('../pages/admin/hire-ad.vue'),
			meta: {
				title: '发布招聘'
			},
		},
		{
			path: '/admin/banner-setting',
			name: 'admin-banner-setting',
			component: () => import('../pages/admin/banner-setting.vue'),
			meta: {
				title: '图片设置'
			},
		},
		{
			path: '/admin/no-authority',
			name: 'admin-no-authority',
			component: () => import('../pages/admin/no-authority.vue'),
			meta: {
				title: '没有权限'
			},
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js